module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('img', {
    attrs: {
      "src": require("../images/404.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("我勒个去，页面被外星人挟持了!去"), _c('span', {
    staticClass: "primary cursor",
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("首页")]), _vm._v("吧")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a38828c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/404.vue
// module id = 933
// module chunks = 0